
/**
 * Created by lv on 2017/11/15.
 */
const Guid=()=>{

    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());

}


module.exports = {
    Guid
}